var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-tabs-wrapper bb-0 mb-2" },
    [
      _c("scrollable-container", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var recalculateWidth = ref.recalculateWidth
              return [
                _c(
                  "ul",
                  {
                    staticClass: "nav nav-tabs p-0",
                    attrs: { role: "tablist" },
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass: "nav-item sticky-tabs",
                        class: [
                          _vm.isCurrentTab("all") ? "navbar-active active" : "",
                          _vm.$i18n.locale === "en-CA"
                            ? "first-tab-english"
                            : "first-tab-french",
                        ],
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "nav-link clickable regular bold text-gray",
                            attrs: { id: "contacts-tab" },
                            on: {
                              click: function ($event) {
                                return _vm.handleChangeSegment("all")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("lists.segments.allContacts")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "nav-item sticky-tabs",
                        class: [
                          _vm.isCurrentTab("add") ? "navbar-active active" : "",
                          _vm.$i18n.locale === "en-CA"
                            ? "second-tab-english"
                            : "second-tab-french",
                        ],
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: {
                                  title: _vm.$t(
                                    "lists.segments.createNewSegment"
                                  ),
                                  placement: "top",
                                  boundary: "window",
                                },
                                expression:
                                  "{\n            title: $t('lists.segments.createNewSegment'),\n            placement: 'top',\n            boundary: 'window'\n          }",
                              },
                            ],
                            staticClass: "nav-link clickable",
                            attrs: {
                              id: "create-tab",
                              role: "tab",
                              "aria-controls": "create",
                              "aria-selected": "false",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleChangeSegment("add")
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa fa-plus" })]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.segments, function (segment) {
                      return _c(
                        "li",
                        {
                          key: segment.id,
                          staticClass: "nav-item mr-0",
                          class: _vm.isCurrentTab(segment.id)
                            ? "navbar-active active"
                            : "",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "nav-link clickable",
                              attrs: {
                                role: "tab",
                                "aria-controls": "create",
                                "aria-selected": "false",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleChangeSegment(segment.id)
                                },
                              },
                            },
                            [
                              _c("segments-nav-editable-tab", {
                                attrs: {
                                  "is-current-tab": _vm.isCurrentTab(
                                    segment.id
                                  ),
                                  "segment-name": segment.name,
                                },
                                on: {
                                  "change-name": _vm.handleChangeName,
                                  editing: recalculateWidth,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }